import { Grid, Tab, Tabs } from "@mui/material";
import React, { useState, useEffect } from "react";

export function TabControl({ panels, defaultTab, onTabChange }) {
  const tabLabels = Array.from(new Set(panels.map(({ label }) => label))).filter((item) => !item.disabled);
  const defaultTabIndex = defaultTab
    ? tabLabels.findIndex((label) => label === defaultTab)
    : 0;
  const [currentTabIndex, changeTabIndex] = useState(defaultTabIndex);
  const [useDefault, setUseDefault] = useState(true);

  useEffect(() => {
    setUseDefault(true);
  }, [defaultTab]);

  useEffect(() => {
    defaultTab &&
      useDefault &&
      changeTabIndex(tabLabels.findIndex((label) => label === defaultTab) || 0);
  }, [defaultTab, tabLabels, useDefault]);

  function handleChange(event, newValue) {
    changeTabIndex(newValue);
    setUseDefault(false);
    //onTabChange(newValue);
  }

  return (
    <Grid>
      <Grid item>
        <Tabs
          value={currentTabIndex}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          className="hide-on-print"
          sx={{
            borderBottom: "1px solid #e8e8e8",
            mt: 2.5,
            mb: 1.25,
          }}
        >
          {tabLabels.map((label) => (
            <Tab key={label} label={label} />
          ))}
        </Tabs>
      </Grid>
      <Grid item>{panels[currentTabIndex].render()}</Grid>
    </Grid>
  );
}
